<script setup lang="ts">
const runtimeConfig = useRuntimeConfig()
const { params, query, path} = useRoute()
const store = useStore()
const { filterLoading } = storeToRefs(store)
const manufacturerStore = useManufacturerStore()
await manufacturerStore.init({ id: params.id, query, url: path })
const { productsData, name, metaTitle, metaDescription } = storeToRefs(manufacturerStore)

const limit = computed(() => manufacturerStore.productsData.limit)
const total = computed(() => manufacturerStore.productsData.total)
const maxPage = computed(() => Math.ceil(total.value / limit.value))

let param = Object.entries(Object.fromEntries(Object.entries(query).filter(([key]) => ['p'].includes(key)))).map(([key, val]) => `${key}=${encodeURIComponent(val)}`).join('&')
if (param.length) {
  param = `?${param}`
}
useHead({
  titleTemplate: `${metaTitle.value} - %s`,
  meta: [
    { name: 'description', content: metaDescription.value },
    { name: 'robots', content: 'noindex,follow' }
  ],
  link: [
    { rel: 'canonical', href: `${runtimeConfig.public.baseUrl}${path}${param}` }
  ]
})
</script>

<template>
  <div class="container mx-auto">
    <Breadcrumbs :breadcrumbs="[{ name }]" />
    <h1 class="text-18 font-bold mb-[20px]">
      Lista produktów wg dostawcy: {{ name }}
    </h1>
    <div v-if="filterLoading" class="sticky top-0 z-10">
      <LoadingIndicator class="w-[100px] h-[100px] absolute top-[200px] left-1/2 -translate-x-1/2" />
    </div>
    <ul :class="{ 'opacity-30': filterLoading, 'after:w-[calc(100%/2-10px)]': productsData.elements.length % 4 === 3, 'md:after:w-[calc(100%/4-10px)]': productsData.elements.length % 4 === 3 }" class="flex flex-wrap justify-center md:justify-between gap-[10px] after:w-[calc(100%/2-10px)] after:max-w-[262px]">
      <li v-for="(p, index) in productsData.elements" :key="p.id" class="group w-[calc(50%-5px)] md:w-[calc(25%-10px)] max-w-[262px]" :data-index="index">
        <ProductListItem :products="p" class="mb-[30px]" />
      </li>
    </ul>
    <ProductListPagination :max-page="maxPage" :load="manufacturerStore.load" />
  </div>
</template>
